import ProcedureduVisaEtudiant from "../../assets/pdf/ProcedureduVisaEtudiant.pdf";
import ProceduredUnCompteBancaire from "../../assets/pdf/ProceduredUnCompteBancaire.pdf";
import BankAccountProcedure from "../../assets/pdf/BankAccountProcedure.pdf";
import StudentVisaProcedure from "../../assets/pdf/StudentVisaProcedure.pdf";

const files = [
  {
    name: "Procedure du Visa Etudiant",
    nameSupport: "ProcedureduVisaEtudiant.pdf",
    type: "PDF",
    pages: "1 Page",
    size: "105 KB",
    icon: (
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5m14 9.006h-.335a1.647 1.647 0 0 1-1.647-1.647v-1.706a1.647 1.647 0 0 1 1.647-1.647L19 12M5 12v5h1.375A1.626 1.626 0 0 0 8 15.375v-1.75A1.626 1.626 0 0 0 6.375 12H5Zm9 1.5v2a1.5 1.5 0 0 1-1.5 1.5v0a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 1.5-1.5v0a1.5 1.5 0 0 1 1.5 1.5Z"
        />
      </svg>
    ),
    path: ProcedureduVisaEtudiant,
  },
  {
    name: "Procedure d'Un Compte Bancaire",
    nameSupport: "ProceduredUnCompteBancaire.pdf",
    type: "PDF",
    pages: "1 Page",
    size: "109 KB",
    icon: (
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5m14 9.006h-.335a1.647 1.647 0 0 1-1.647-1.647v-1.706a1.647 1.647 0 0 1 1.647-1.647L19 12M5 12v5h1.375A1.626 1.626 0 0 0 8 15.375v-1.75A1.626 1.626 0 0 0 6.375 12H5Zm9 1.5v2a1.5 1.5 0 0 1-1.5 1.5v0a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 1.5-1.5v0a1.5 1.5 0 0 1 1.5 1.5Z"
        />
      </svg>
    ),
    path: ProceduredUnCompteBancaire,
  },
  {
    name: "Bank Account Procedure",
    nameSupport: "BankAccountProcedure.pdf",
    type: "PDF",
    pages: "1 Page",
    size: "107 KB",
    icon: (
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5m14 9.006h-.335a1.647 1.647 0 0 1-1.647-1.647v-1.706a1.647 1.647 0 0 1 1.647-1.647L19 12M5 12v5h1.375A1.626 1.626 0 0 0 8 15.375v-1.75A1.626 1.626 0 0 0 6.375 12H5Zm9 1.5v2a1.5 1.5 0 0 1-1.5 1.5v0a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 1.5-1.5v0a1.5 1.5 0 0 1 1.5 1.5Z"
        />
      </svg>
    ),
    path: BankAccountProcedure,
  },
  {
    name: "Student Visa Procedure",
    nameSupport: "StudentVisaProcedure.pdf",
    type: "PDF",
    pages: "1 Page",
    size: "103 KB",
    icon: (
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 10V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1v6M5 19v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1M10 3v4a1 1 0 0 1-1 1H5m14 9.006h-.335a1.647 1.647 0 0 1-1.647-1.647v-1.706a1.647 1.647 0 0 1 1.647-1.647L19 12M5 12v5h1.375A1.626 1.626 0 0 0 8 15.375v-1.75A1.626 1.626 0 0 0 6.375 12H5Zm9 1.5v2a1.5 1.5 0 0 1-1.5 1.5v0a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 1.5-1.5v0a1.5 1.5 0 0 1 1.5 1.5Z"
        />
      </svg>
    ),
    path: StudentVisaProcedure,
  },
];

export default function RecentUploads() {
  return (
    <div className="dark:bg-gray-900 min-h-screen text-gray-600 dark:text-white px-10 py-8">
      <h2 className="text-2xl font-bold mb-6">Téléchargements récents</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5">
        {files.map((file, index) => (
          <div
            key={index}
            className="bg-gray-50 dark:bg-gray-800 dark:border dark:border-gray-700  p-4 rounded-lg shadow-lg flex flex-col justify-between  transition-all duration-300"
          >
            <div className="flex items-center space-x-3 mb-4">
              {file.icon}
              <span className="font-semibold">{file.name}</span>
            </div>

            <div className="text-sm text-gray-400 space-x-2">
              {file.pages && <span>{file.pages}</span>}
              {file.size && <span>• {file.size}</span>}
              <span>• {file.type}</span>
            </div>

            <a
              href={file.path}
              download
              className="mt-4 text-gray-700 dark:text-white text-sm flex items-center gap-1 justify-center dark:bg-[#243b6b] bg-gray-100 dark:hover:bg-blue-800 hover:bg-blue-300 transition rounded-md py-2"
            >
              <svg
                className="w-6 h-6 text-gray-800 dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 13V4M7 14H5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-2m-1-5-4 5-4-5m9 8h.01"
                />
              </svg>
              Télécharger
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
